// extracted by mini-css-extract-plugin
export default {"formNoticeContainer":"FormNotice_formNoticeContainer__OikrO"};